export const BidCheckStatuses = {
  PASS: true,
  FAIL: false
};
